export default
{
    "status": 0,
    "data": [
        {
            "COMM_CD_NM": "밀",
            "COMM_CD_KO_NM": "밀",
            "COMM_CD_JP_NM": "小麦",
            "COMM_CD_EN_NM": "Wheat",
            "COMM_CD_CN_NM": null,
            "COMM_CD_TW_NM": "麥子",
            "CP_CD": "0801",
            "GRP_CD": "00300",
            "COMM_CD": "01"
        },
        {
            "COMM_CD_NM": "계란",
            "COMM_CD_KO_NM": "계란",
            "COMM_CD_JP_NM": "卵",
            "COMM_CD_EN_NM": "Egg",
            "COMM_CD_CN_NM": null,
            "COMM_CD_TW_NM": "雞蛋",
            "CP_CD": "0801",
            "GRP_CD": "00300",
            "COMM_CD": "02"
        },
        {
            "COMM_CD_NM": "우유",
            "COMM_CD_KO_NM": "우유",
            "COMM_CD_JP_NM": "乳",
            "COMM_CD_EN_NM": "Milk",
            "COMM_CD_CN_NM": null,
            "COMM_CD_TW_NM": "牛奶",
            "CP_CD": "0801",
            "GRP_CD": "00300",
            "COMM_CD": "03"
        },
        {
            "COMM_CD_NM": "땅콩",
            "COMM_CD_KO_NM": "땅콩",
            "COMM_CD_JP_NM": "落花生",
            "COMM_CD_EN_NM": "Peanut",
            "COMM_CD_CN_NM": null,
            "COMM_CD_TW_NM": "花生",
            "CP_CD": "0801",
            "GRP_CD": "00300",
            "COMM_CD": "04"
        },
        {
            "COMM_CD_NM": "메밀",
            "COMM_CD_KO_NM": "메밀",
            "COMM_CD_JP_NM": "そば",
            "COMM_CD_EN_NM": "Buckwheat",
            "COMM_CD_CN_NM": null,
            "COMM_CD_TW_NM": "蕎麥",
            "CP_CD": "0801",
            "GRP_CD": "00300",
            "COMM_CD": "05"
        },
        {
            "COMM_CD_NM": "새우",
            "COMM_CD_KO_NM": "새우",
            "COMM_CD_JP_NM": "えび",
            "COMM_CD_EN_NM": "Shrimp",
            "COMM_CD_CN_NM": null,
            "COMM_CD_TW_NM": "蝦",
            "CP_CD": "0801",
            "GRP_CD": "00300",
            "COMM_CD": "06"
        },
        {
            "COMM_CD_NM": "게",
            "COMM_CD_KO_NM": "게",
            "COMM_CD_JP_NM": "かに",
            "COMM_CD_EN_NM": "Crab",
            "COMM_CD_CN_NM": null,
            "COMM_CD_TW_NM": "螃蟹",
            "CP_CD": "0801",
            "GRP_CD": "00300",
            "COMM_CD": "07"
        },
        {
            "COMM_CD_NM": "생선",
            "COMM_CD_KO_NM": "생선",
            "COMM_CD_JP_NM": "魚",
            "COMM_CD_EN_NM": "Fish",
            "COMM_CD_CN_NM": null,
            "COMM_CD_TW_NM": "海鮮",
            "CP_CD": "0801",
            "GRP_CD": "00300",
            "COMM_CD": "08"
        },
        {
            "COMM_CD_NM": "견과류",
            "COMM_CD_KO_NM": "견과류",
            "COMM_CD_JP_NM": "ナッツ",
            "COMM_CD_EN_NM": "Nuts",
            "COMM_CD_CN_NM": null,
            "COMM_CD_TW_NM": "堅果類",
            "CP_CD": "0801",
            "GRP_CD": "00300",
            "COMM_CD": "09"
        }
    ],
    "message": ""
}